//BootStrap DropDown. props.
// .onUpdate = state change callback (gets index of selected)
// .currentValue = index of active item
// .options = drop down display choices
// .anchorStyle = className for anchor, .itemStyle = className for dropdown items
import React, { Component } from 'react';
import {Dropdown} from 'react-bootstrap'

import './period-dropdown.css';

export default class DropDown2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: props?.value,
      currentIndex: undefined
    }
    this.placeholder = "Select one";
    this.clickedItem = this.clickedItem.bind(this);
  }
  componentDidMount () {
    this.initDropdown()
  }
  componentDidUpdate(prevprops) {
    if (prevprops?.value !== this.props?.value) {
      this.initDropdown()
    }
  }
  initDropdown() {
    const index = this.props?.options.indexOf (this.props?.value)
    this.setState({currentIndex: index})
  }
  clickedItem(index) {
    this.setState({currentIndex: index})
    if ('function' === typeof this.props?.onUpdate) this.props.onUpdate (index)
  }

  render() {

    const list = this.props?.options??this.placeholder;
    const active = this.state.currentIndex;
    const itemStyle = this.props?.itemStyle??"menu-item"
    const disabled = this.props?.readOnly ?? false
    return(
    <Dropdown>
      <Dropdown.Toggle className={this.props?.anchorStyle} disabled={disabled} >
        {typeof active === 'number' && active > -1 ? list[active] : this.placeholder}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {list.map((item, index) => 
          <Dropdown.Item className={itemStyle} key={index} onClick={()=>this.clickedItem(index)} active={index===active}>
            {list[index]} 
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
   )
  }
}
